import React from 'react'
import PropTypes from 'prop-types'
import CheckboxTheme from '~/components/common/Checkbox'

const Checkbox = ({ field, meta, form, disabled, ...props }) => (
  <CheckboxTheme
    checked={!!field.value}
    error={meta.touched && !!meta.error}
    disabled={disabled || !!form.values.__readOnly}
    {...field}
    {...props}
  />
)

Checkbox.defaultProps = {
  meta: {},
  disabled: false,
}

Checkbox.propTypes = {
  form: PropTypes.shape().isRequired,
  field: PropTypes.shape().isRequired,
  meta: PropTypes.shape(),
  disabled: PropTypes.bool,
}

export default Checkbox
